import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import styled from "styled-components";

const PaymentFormulasCalculator = ({profileData, data, formulaTableData, history, addPaymentFormulas, patchPaymentFormulas, formulaId, permissions}) => {

  const absData = data?.filter(i => i.is_absolute);
  const calcData = data?.filter(i => !i.is_absolute);

  const [inputValue, setInputValue] = useState(profileData?.formula || '');
  const [isOpenAbs, setOpenAbs] = useState(false);
  const [isOpenCalc, setOpenCalc] = useState(false);

  const [absParams, setAbsParams] = useState(absData);
  const [calcParams, setCalcParams] = useState(calcData);

  useEffect(() => {
    if (data){
      let absData = data?.filter(i => i.is_absolute);
      let calcData = data?.filter(i => !i.is_absolute);
      setAbsParams(absData);
      setCalcParams(calcData);
    }
  }, [data]);

  useEffect(() => {
    if (profileData){
      setInputValue(profileData?.formula);
    }
  }, [profileData]);

  const handleAddValue = val => {
    handleChangeValue(inputValue + val);
  }

  const handleAddSelectedValue = e => {
    handleChangeValue(inputValue + e.currentTarget.textContent);
  }

  const handleChangeValue = inputValue => setInputValue(inputValue);

  const formSubmit = () => {
    //console.log(inputValue);
    if (formulaId) {
      patchPaymentFormulas(formulaId, inputValue, formulaTableData);
    } else {
      addPaymentFormulas(inputValue, formulaTableData);
    }
    history.push('/payment-formulas');
  };

  return (
    <Row>
      <Col lg="16">
        <AvForm className="needs-validation" onSubmit={formSubmit}>
          <Card>
            <CardBody>
              <Row className="justify-content-center">
                <h4 className="card-title" align="center">
                  Payment formulas
                </h4>
                <Col xl="6" lg="8" align="center">
                  <Row className="mb-2">
                    <Col>
                      <input
                        name="payment_formula"
                        type="text"
                        value={inputValue || ''}
                        // errorMessage="Please provide a valid payment_formula."
                        className="form-control"
                        onChange={e =>
                          handleChangeValue(e.target.value)
                        }
                        disabled
                        // validate={{ required: { value: true } }}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={6}>
                      {absParams && <ButtonDropdown
                        className="w-100"
                        isOpen={isOpenAbs}
                        toggle={() =>
                          setOpenAbs(!isOpenAbs)
                        }
                        plug="Absolute params"
                      >
                        <DropdownToggle
                          className="btn btn-secondary dropdown-btn-hidden-columns w-100"
                          caret
                        >
                          Absolute params
                          <i className="mdi mdi-chevron-down" />
                        </DropdownToggle>
                        <DropdownSelectStyled>
                          {absParams.map(i => <DropdownItem onClick={handleAddSelectedValue} key={i.id}>{i.name}</DropdownItem>)}
                        </DropdownSelectStyled>
                      </ButtonDropdown>}
                    </Col>
                    <Col md={6}>
                      {calcParams && <ButtonDropdown
                        className="w-100"
                        isOpen={isOpenCalc}
                        toggle={() =>
                          setOpenCalc(!isOpenCalc)
                        }
                        plug="Calculated params"
                        onChange={handleAddValue}
                      >
                        <DropdownToggle
                          className="btn btn-secondary dropdown-btn-hidden-columns w-100"
                          caret
                        >
                          Calculated params
                          <i className="mdi mdi-chevron-down" />
                        </DropdownToggle>
                        <DropdownSelectStyled>
                          {/*<div className={`d-block pointer-event dropdown-search-field`}>*/}
                          {/*  <label htmlFor="search-bar-0" className="search-label">*/}
                          {/*    <input*/}
                          {/*      id="search-bar-0"*/}
                          {/*      type="text"*/}
                          {/*      aria-labelledby="search-bar-0-label"*/}
                          {/*      className="form-control"*/}
                          {/*      onChange={e =>*/}

                          {/*        absData.filter(*/}
                          {/*          i =>*/}
                          {/*            i.name*/}
                          {/*              .toLowerCase()*/}
                          {/*              .indexOf(e.target.value.toLowerCase()) !== -1*/}
                          {/*        )*/}

                          {/*      }*/}
                          {/*      placeholder="Search"*/}
                          {/*    />*/}
                          {/*  </label>*/}
                          {/*</div>*/}
                          {calcParams.map(i => <DropdownItem onClick={handleAddSelectedValue} key={i.id}>{i.name}</DropdownItem>)}
                        </DropdownSelectStyled>
                      </ButtonDropdown>}
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleAddValue("(")}
                      >
                        (
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleAddValue(")")}
                      >
                        )
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleAddValue("(")}
                      >
                        %
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleChangeValue("")}
                      >
                        AC
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("7")}
                      >
                        7
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("8")}
                      >
                        8
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("9")}
                      >
                        9
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleAddValue("/")}
                      >
                        /
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("4")}
                      >
                        4
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("5")}
                      >
                        5
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("6")}
                      >
                        6
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleAddValue("*")}
                      >
                        *
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("1")}
                      >
                        1
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("2")}
                      >
                        2
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("3")}
                      >
                        3
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleAddValue("-")}
                      >
                        -
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={6}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue("0")}
                      >
                        0
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        outline
                        onClick={() => handleAddValue(".")}
                      >
                        .
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button
                        color="secondary"
                        className="w-100"
                        onClick={() => handleAddValue("+")}
                      >
                        +
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col className="col-12" align="center">
                  {permissions?.['change_paymentformulamodel'] && <Button
                    style={{ margin: "25px 0" }}
                    type="submit"
                    color="success"
                  >
                    Save formula
                  </Button>}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </AvForm>
      </Col>
    </Row>
  );
};

const DropdownSelectStyled = styled(DropdownMenu)`
  height: 250px;
  width: 100%;
  overflow-y: auto;
`

PaymentFormulasCalculator.propTypes = {
  data: PropTypes.any,
  profileData: PropTypes.any,
  formulaTableData: PropTypes.any,
  history: PropTypes.any,
  formulaId: PropTypes.any,
  addPaymentFormulas: PropTypes.func,
  patchPaymentFormulas: PropTypes.func,
  permissions: PropTypes.any,
};

export default PaymentFormulasCalculator;
